<template>
	<div>
		<div style="width: 75rem;margin: 0 auto">
			<p style="font-size: 20px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: bold;
			color: #333333;margin: 0;display: flex;justify-content: center;margin-top: 2rem;">
						{{title}}
					</p>
		</div>
		<div v-html="detailed" style="width: 75rem;margin: 0 auto;margin-top: 2rem;">

		</div>

	</div>
</template>

<script>
	import {
		newsDetail
	} from '../../../common/api.js'
	export default {
		data() {
			return {
				newsDetail,
				newsDetailData: [],
				detailed: '',
				title: '',
			}
		},
		created() {
			document.documentElement.scrollTop = 0
			this.getNewsDetail()
		},
		methods: {
			async getNewsDetail() {
				let id = this.$route.query.id
				const res = await this.newsDetail({
					id: id + ''
				})
				console.log(res)
				// this.newsDetailData=res.Data
				this.detailed = res.data.Data.detailed
				this.title = res.data.Data.title
			}
		}
	}
</script>

<style>
</style>
